import Steps8 from './Steps8'
export default Steps8
